import { Link } from "react-router-dom";
import { MarketingLayout } from "@/components/MarketingLayout";

export default function NotFound() {
  return (
    <MarketingLayout>
      <div className="max-w-xl mx-auto w-full px-6 py-24 text-center">
        <h1 className="text-3xl font-semibold tracking-tight text-slate-900">
          Not found
        </h1>
        <p className="mt-3 text-slate-600">
          We couldn&rsquo;t find the page you were looking for.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-full bg-slate-900 px-5 py-2.5 text-sm font-medium text-white hover:bg-slate-800"
        >
          Back home
        </Link>
      </div>
    </MarketingLayout>
  );
}
